import React from 'react';
import { Link } from 'react-router';
import { TENANT } from 'new/tenants';

type Props = {
  remediationLink?: string | null;
};

export const StripeRestrictedInfo: React.FC<Props> = ({ remediationLink }) => {
  return remediationLink != null ? (
    remediationLink == 'billing' ? (
      <span style={{ textAlign: 'center' }}>
        There is an issue with payouts to your bank account.
        <br />
        <br />
        Please update your Bank Account information on the{' '}
        <Link to="/account/settings/billing">Billing page</Link> to resolve the
        issue.
        <br />
        <br />
        Payouts will be on hold until resolved.
      </span>
    ) : (
      <span style={{ textAlign: 'center' }}>
        Your account has an issue with our payment processor, Stripe.
        <br />
        <br />
        <span>
          The business owner can use{' '}
          <Link target="_blank" to={remediationLink}>
            this link
          </Link>{' '}
          or contact{' '}
          <Link to={'mailto:' + TENANT.supportEmail}>
            {TENANT.supportEmail}
          </Link>{' '}
          to resolve the issue.
          <br />
          <br />
          Enrollment, payments, or payouts may be on hold until resolved.
        </span>
      </span>
    )
  ) : (
    <span style={{ textAlign: 'center' }}>
      Contact{' '}
      <Link to={'mailto:' + TENANT.supportEmail}>{TENANT.supportEmail}</Link> or
      your Account Manager.
      <br />
      <br />
      Enrollment, payments, or payouts may be on hold until resolved.
    </span>
  );
};

export default StripeRestrictedInfo;
